import { isPolygonClosed as l } from "@project-rouge/rg-core";
function i(s) {
  const o = s.slice();
  l(o) || o.push(o[0]);
  const e = [];
  for (let n = 0; n < o.length - 1; n++)
    e.push([o[n], o[n + 1]]);
  return e;
}
export {
  i as getLinesFromPolygon
};
//# sourceMappingURL=index9.js.map
